module.exports = __webpack_public_path__ + "images/img-mk.4c0b3f22.jpg";